import { z } from 'zod';
import { ParentContactId, FamilyId } from '../types/branded';
import { ParentRelationSchema } from '../types/enums';

export const ParentContactSchema = z.object({
  id: ParentContactId,
  familyId: FamilyId,
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  email: z.string().nullable().optional(),
  phone: z.string().nullable().optional(),
  relation: ParentRelationSchema,
  isPrimary: z.boolean().default(false),
  title: z.string().nullable().optional(),
  prefix: z.string().nullable().optional(),
  maidenName: z.string().nullable().optional(),
  occupation: z.string().nullable().optional(),
  firm: z.string().nullable().optional(),
  firmName: z.string().nullable().optional(),
  company: z.string().nullable().optional(),
  employer: z.string().nullable().optional(),
  nameOfFirm: z.string().nullable().optional(),
  addressStreet: z.string().nullable().optional(),
  addressCity: z.string().nullable().optional(),
  addressState: z.string().nullable().optional(),
  addressZip: z.string().nullable().optional(),
  receivesComms: z.boolean().default(true),
  createdAt: z.string(),
});
export type ParentContact = z.infer<typeof ParentContactSchema>;
